import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Encuestas", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Eliminar encuesta", -1)

import { AuthService, SystemUser } from '@/services/auth/authService';
import { ResumedSurveyData } from '@/services/survey-response/models/surveyModels';
import { SurveyRespondeService } from '@/services/survey-response/surveyRespondeService';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toast-notification';


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveysView',
  setup(__props) {

const router = useRouter();
const surveyResponseService = new SurveyRespondeService();
const authService = new AuthService();
const surveys = ref<ResumedSurveyData[]>([]);
const users = ref<SystemUser[]>([]);
const toast = useToast();
const loadingSurveys = ref(true);

async function fetchSurveys() {
    loadingSurveys.value = true;
    try {
        surveys.value = (await surveyResponseService.getAllSurveys() || []).sort((a, b) => b.id - a.id);
    } catch (error) {
        console.error('Error fetching surveys:', error);
        toast.error('No se pudieron cargar las encuestas');
    } finally {
        loadingSurveys.value = false;
    }
}

async function fetchUsers() {
    try {
        const response = await authService.getAllUsers();
        if (response) users.value = response;
    } catch (error) {
        console.error('Error fetching users:', error);
    }
}

function getUserName(userId: number): string {
    const user = users.value.find(user => user.id === userId);
    return user ? `${user.name} (${user.username})` : 'Usuario desconocido';
}

function editSurvey(survey: ResumedSurveyData) {
    router.push({ name: 'Survey', params: { id: survey.id } });
}

const showDeleteConfirmation = ref(false);
const toDeleteSurvey = ref<ResumedSurveyData>();

async function removeSurvey() {
    if (!toDeleteSurvey.value) {
        toast.error('No se pudo eliminar la encuesta');
        return;
    }

    try {
        const response = await surveyResponseService.deleteSurvey(toDeleteSurvey.value.id);
        if (!response) throw new Error('No se pudo eliminar la encuesta');
        toast.success('Encuesta eliminada correctamente');
        await fetchSurveys();
    } catch (error) {
        console.error('Error removing survey:', error);
        toast.error('No se pudo eliminar la encuesta. Hable con soporte');
    } finally {
        showDeleteConfirmation.value = false;
        toDeleteSurvey.value = undefined;
    }
}

function confirmDeleteSurvey(survey: ResumedSurveyData) {
    toDeleteSurvey.value = survey;
    showDeleteConfirmation.value = true;
}

onMounted(() => {
    fetchSurveys();
    fetchUsers();
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            (loadingSurveys.value)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: "",
                  color: "primary",
                  class: "mb-4"
                }))
              : (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surveys.value, (survey) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: survey.id
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            onClick: ($event: any) => (editSurvey(survey)),
                            icon: "mdi-pencil",
                            color: "primary",
                            variant: "text",
                            size: "small"
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            onClick: ($event: any) => (confirmDeleteSurvey(survey)),
                            icon: "mdi-delete",
                            color: "red",
                            variant: "text",
                            size: "small"
                          }, null, 8, ["onClick"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode("Encuesta " + _toDisplayString(survey.id), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_list_item_subtitle, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(getUserName(survey.userId)), 1),
                              (survey.date)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(" — " + _toDisplayString(survey.date), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    (surveys.value.length === 0)
                      ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { class: "text-center text-grey" }, {
                              default: _withCtx(() => [
                                _createTextVNode("No hay encuestas")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: showDeleteConfirmation.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDeleteConfirmation).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-alert-circle",
                  color: "red"
                }),
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode("¿Está seguro de que desea eliminar la encuesta " + _toDisplayString(toDeleteSurvey.value?.id) + "?", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "d-flex justify-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showDeleteConfirmation.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cancelar")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  onClick: removeSurvey,
                  color: "red",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Eliminar")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})